(function(){
  document.documentElement.classList.remove('no-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var I = window.PIOSA_I18N || {root:'/',add:'Add to bag',addPrice:'Add to bag — __P__',sold:'Sold out',inStock:'In stock — ready to ship',unavailable:'Unavailable'};

  // keep the chosen language while navigating: prefix root-relative links with the locale folder (e.g. /es)
  if (I.root && I.root !== '/') {
    var pre = I.root.replace(/\/$/, '');
    document.querySelectorAll('a[href^="/"]').forEach(function(a){
      var h = a.getAttribute('href');
      if (h.indexOf('//') === 0 || h === pre || h.indexOf(pre + '/') === 0 || h.indexOf(pre + '?') === 0 || /^\/(cdn|checkout|apps|cart\/(add|change|clear))/.test(h)) return;
      a.setAttribute('href', pre + h);
    });
  }

  // hero slideshow
  document.querySelectorAll('[data-slideshow]').forEach(function(root){
    var slides = root.querySelectorAll('.slide');
    var dots = root.querySelectorAll('[data-dot]');
    var count = root.querySelector('[data-count]');
    var i = 0, timer = null, delay = parseInt(root.dataset.delay || '7000', 10);
    function go(n){
      slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden','true');
      if (dots[i]) dots[i].setAttribute('aria-current','false');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); slides[i].setAttribute('aria-hidden','false');
      if (dots[i]) dots[i].setAttribute('aria-current','true');
      if (count) count.textContent = ('0'+(i+1)).slice(-2) + ' / ' + ('0'+slides.length).slice(-2);
    }
    function play(){ if (reduce || slides.length < 2) return; stop(); timer = setInterval(function(){ go(i+1); }, delay); }
    function stop(){ if (timer) clearInterval(timer); timer = null; }
    dots.forEach(function(d,k){ d.addEventListener('click', function(){ go(k); play(); }); });
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function(){ go(i-1); play(); });
    if (next) next.addEventListener('click', function(){ go(i+1); play(); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    document.addEventListener('visibilitychange', function(){ if (document.hidden) stop(); else play(); });
    var x0 = null;
    root.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive:true});
    root.addEventListener('touchend', function(e){ if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) { go(dx < 0 ? i+1 : i-1); play(); } x0 = null; });
    play();
  });

  // search toggle
  document.querySelectorAll('[data-search-toggle]').forEach(function(b){
    b.addEventListener('click', function(){
      var p = document.getElementById('SearchPanel'); if (!p) return;
      var open = p.classList.toggle('open'); b.setAttribute('aria-expanded', open);
      if (open) { var inp = p.querySelector('input'); if (inp) inp.focus(); }
    });
  });

  // mobile drawer
  var drawer = document.getElementById('MenuDrawer');
  document.querySelectorAll('[data-drawer-open]').forEach(function(b){ b.addEventListener('click', function(){ drawer.classList.add('open'); b.setAttribute('aria-expanded','true'); var c = drawer.querySelector('[data-drawer-close]'); if (c) c.focus(); }); });
  document.querySelectorAll('[data-drawer-close]').forEach(function(b){ b.addEventListener('click', function(){ drawer.classList.remove('open'); }); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && drawer) drawer.classList.remove('open'); });

  // mega menu (click/touch)
  document.querySelectorAll('.has-mega > button').forEach(function(b){
    b.addEventListener('click', function(){ var li = b.parentElement; var o = li.classList.toggle('open'); b.setAttribute('aria-expanded', o); });
  });
  document.addEventListener('click', function(e){ document.querySelectorAll('.has-mega.open').forEach(function(li){ if (!li.contains(e.target)) { li.classList.remove('open'); li.querySelector('button').setAttribute('aria-expanded','false'); } }); });

  // reveal on scroll (content stays visible without JS)
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function(es){ es.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }); }, {rootMargin:'0px 0px -8% 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else { document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); }); }

  // product gallery
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var stage = g.querySelector('[data-stage]');
    g.querySelectorAll('[data-thumb]').forEach(function(t){
      t.addEventListener('click', function(){
        stage.src = t.dataset.src; stage.srcset = t.dataset.srcset || ''; stage.alt = t.dataset.alt || '';
        g.querySelectorAll('[data-thumb]').forEach(function(o){ o.setAttribute('aria-current','false'); });
        t.setAttribute('aria-current','true');
      });
    });
  });

  // quantity
  document.querySelectorAll('[data-qty]').forEach(function(q){
    var inp = q.querySelector('input');
    q.querySelectorAll('button').forEach(function(b){ b.addEventListener('click', function(){ var v = parseInt(inp.value||'1',10) + (b.dataset.step === '+' ? 1 : -1); inp.value = Math.max(1, v); }); });
  });

  // variant picker
  document.querySelectorAll('#ProductForm').forEach(function(f){
    var dataEl = f.querySelector('[data-variants]'); if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var selects = f.querySelectorAll('[data-option]');
    var idInput = f.querySelector('input[name="id"]');
    var price = document.querySelector('[data-price]');
    var btns = document.querySelectorAll('[data-add-btn]');
    var money = function(c){ return '$' + (c/100).toFixed(2); };
    function update(){
      var opts = Array.prototype.map.call(selects, function(s){ return s.value; });
      var v = variants.find(function(x){ return x.options.every(function(o,k){ return o === opts[k]; }); });
      btns.forEach(function(b){
        if (!v) { b.disabled = true; b.textContent = I.unavailable; return; }
        b.disabled = !v.available; b.textContent = v.available ? (b.hasAttribute('data-sticky-submit') ? I.add : I.addPrice.replace('__P__', money(v.price))) : I.sold;
      });
      var av = document.querySelector('[data-avail]');
      if (av) { av.classList.toggle('no', !(v && v.available)); av.querySelector('span').textContent = v ? (v.available ? I.inStock : I.sold) : I.unavailable; }
      if (!v) return;
      idInput.value = v.id;
      var sp = document.querySelector('[data-sticky-price]'); if (sp) sp.textContent = money(v.price);
      if (price) price.innerHTML = money(v.price) + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '');
      if (v.featured_image && document.querySelector('[data-stage]')) { var st = document.querySelector('[data-stage]'); st.src = v.featured_image.src + (v.featured_image.src.indexOf('?')>-1?'&':'?') + 'width=1200'; st.removeAttribute('srcset'); }
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
    }
    selects.forEach(function(s){ s.addEventListener('change', update); });
  });

  // sticky buy (mobile) submits main product form
  document.querySelectorAll('[data-sticky-submit]').forEach(function(b){ b.addEventListener('click', function(){ var f = document.getElementById(b.dataset.stickySubmit); if (f) f.requestSubmit ? f.requestSubmit() : f.submit(); }); });

  // sort select on collection pages
  document.querySelectorAll('[data-sort]').forEach(function(s){ s.addEventListener('change', function(){ var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); window.location = u.toString(); }); });

  // back to top
  document.querySelectorAll('[data-top]').forEach(function(b){ b.addEventListener('click', function(){ window.scrollTo({top:0, behavior: reduce ? 'auto' : 'smooth'}); }); });

  // texture shade selector: swaps the displayed gel texture (crossfade), updates label + shop link
  document.querySelectorAll('[data-texture]').forEach(function(t){
    var layers = t.querySelectorAll('[data-layer]');
    var shade = t.querySelector('[data-tex-shade]');
    var nameEl = t.querySelector('[data-tex-name]');
    var link = t.querySelector('[data-tex-link]');
    var btns = t.querySelectorAll('[data-shade]');
    if ('IntersectionObserver' in window) { var wio = new IntersectionObserver(function(es){ if (es[0].isIntersecting) { layers.forEach(function(l){ l.loading = 'eager'; }); wio.disconnect(); } }, {rootMargin:'400px'}); wio.observe(t); }
    btns.forEach(function(b){
      b.addEventListener('click', function(){
        var n = b.dataset.shade;
        var target = t.querySelector('[data-layer="' + n + '"]');
        var show = function(){ layers.forEach(function(l){ l.classList.toggle('is-on', l.dataset.layer === n); }); };
        if (target && !target.complete && target.decode) { target.loading = 'eager'; target.decode().then(show, show); } else { show(); }
        btns.forEach(function(o){ o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        if (shade) shade.classList.toggle('is-light', b.dataset.light === 'true');
        if (nameEl) nameEl.textContent = b.dataset.name;
        if (link && b.dataset.url) { link.href = b.dataset.url; if (b.dataset.label) link.textContent = b.dataset.label; }
      });
    });
  });

  // texture video: play only when visible
  document.querySelectorAll('video[data-lazy-video]').forEach(function(v){
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
    if (!('IntersectionObserver' in window)) { v.play(); return; }
    new IntersectionObserver(function(es){ es.forEach(function(en){ if (en.isIntersecting) { if (!v.src && v.dataset.src) { v.src = v.dataset.src; } v.play().catch(function(){}); } else { v.pause(); } }); }, {threshold:.15}).observe(v);
  });
})();
